/* **************************************************** Finishing Shedule Order */
export interface FSDataOrder {
    id: number;
    category: 'Light' | 'Door' | 'Paint' | 'Bathroom' | 'Kitchen' | 'Tiles' | 'Floor Finishing' | 'Others';
    status: 'Pending' | 'Ordered' | 'Instore' | 'Onsite';
    lead_time_week: number | null;
    lead_time_day: number | null;
    order_date: string | null;
    instore_date: string | null;
    onsite_date: string | null;
    is_price_include: 1 | 0;
    price: number | null;
    is_include_vat: 1 | 0;
    note: string | null;
    is_accessory_data: 1 | 0;
    order_add_id: number | null;
    date: string | null;
}

export const mapFSDataOrder = (data: any): FSDataOrder => {
    if (!data) {
        throw new Error("Invalid Data");
    }

    const res: FSDataOrder = {
        id: data.id,
        category: data.category,
        status: data.status,
        lead_time_week: data.lead_time_week || null,
        lead_time_day: data.lead_time_day || null,
        order_date: data.order_date || null,
        instore_date: data.instore_date || null,
        onsite_date: data.onsite_date || null,
        is_price_include: data.is_price_include,
        price: data.price || null,
        is_include_vat: data.is_include_vat,
        note: data.note || null,
        is_accessory_data: data.is_accessory_data,
        order_add_id: data.order_add_id || null,
        date: data.date || null,
    };

    return res;
};

export const mapFSDataOrders = (data: any[]): FSDataOrder[] => {
    if (!Array.isArray(data)) {
        throw new Error("Invalid Data");
    }

    return data.map(mapFSDataOrder);
};
